import { render } from "./checkoutStepPayment.vue?vue&type=template&id=679bafd8"
import script from "./checkoutStepPayment.vue?vue&type=script&lang=js"
export * from "./checkoutStepPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__